import getElementMargins from "./getElementMargins.js";
export default (function (rect, element) {
  var margins = getElementMargins(element);
  return {
    width: rect.width + margins.left + margins.right,
    height: rect.height + margins.top + margins.bottom,
    y: rect.y - margins.top,
    x: rect.x - margins.left
  };
});